exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-2d47ea16] .gridcard div.parent .v-card {\r\n  display: none !important;\n}\n[data-v-2d47ea16] .ag-root-wrapper-body.ag-layout-normal {\r\n  height: auto !important;\n}\r\n", ""]);

// exports
